"use client";

import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, SendHorizontal, Mail, ShieldCheck, FileText, AlertCircle, Check } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) return <div className="space-y-3"><div className="h-5 w-24 bg-muted animate-pulse rounded" /></div>;
  if (!menuItems?.length) return null;
  return <ul className="space-y-3">
    {menuItems.map(item => <li key={item.id}>
      <Link to={item.href || "#"} className="text-slate-400 hover:text-cyan-400 transition-colors text-sm font-sans">
        {item.label}
      </Link>
    </li>)}
  </ul>;
}
export default function Footer() {
  const [copied, setCopied] = useState(false);
  const email = "p2wstore.com@gmail.com";
  const copyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <footer className="bg-[#0a0a0c] text-slate-300 border-t border-slate-800 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://genuine-dogfish-1.10web.cloud/wp-content/uploads/2026/04/logo-1.png" alt="P2W Logo" className="w-[100px]" />
            </Link>
            <p className="text-sm leading-relaxed text-slate-500">
              The premier marketplace for gamers. Secure, fast, and reliable trading for all your favorite titles. Level up your game with P2W.
            </p>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6 flex items-center gap-2">
              <ShieldCheck size={18} className="text-cyan-500" /> Legal
            </h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/terms" className="hover:text-cyan-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-cyan-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/refund" className="hover:text-cyan-400 transition-colors">Refund Policy</Link></li>
              <li><Link to="/how-to-buy" className="hover:text-cyan-400 transition-colors">How to Buy</Link></li>
              <li><Link to="/news" className="hover:text-cyan-400 transition-colors">News And Updates</Link></li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6 flex items-center gap-2">
              <AlertCircle size={18} className="text-cyan-500" /> Support
            </h4>
            <MenuProvider menu_id="48">
              <FooterMenuConsumer />
            </MenuProvider>
            
            <div onClick={copyEmail} className="mt-6 flex items-center gap-2 text-sm text-cyan-500 hover:text-white cursor-pointer transition-all">
              <Mail size={16} /> 
              {copied ? <span className="text-green-500 flex items-center gap-1"><Check size={14} /> Copied!</span> : email}
            </div>
          </div>

          {/* Community Column */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6">Join Community</h4>
            <div className="flex gap-4">
              <a href="YOUR_FACEBOOK_LINK" target="_blank" rel="noopener noreferrer" className="p-3 bg-slate-900 rounded-lg hover:bg-blue-900/30 hover:text-blue-400 transition-all border border-slate-800">
                <Facebook size={20} />
              </a>
              <a href="YOUR_TELEGRAM_LINK" target="_blank" rel="noopener noreferrer" className="p-3 bg-slate-900 rounded-lg hover:bg-sky-900/30 hover:text-sky-400 transition-all border border-slate-800">
                <SendHorizontal size={20} />
              </a>
              <a href="YOUR_DISCORD_LINK" target="_blank" rel="noopener noreferrer" className="p-3 bg-slate-900 rounded-lg hover:bg-indigo-600 hover:text-white transition-all border border-slate-800 flex items-center justify-center">
                <svg viewBox="0 0 24 24" fill="currentColor" className="size-5">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.1 18.099a.082.082 0 0 0 .031.058a20.537 20.537 0 0 0 6.096 3.097a.076.076 0 0 0 .081-.027a14.77 14.77 0 0 0 1.282-1.92a.075.075 0 0 0-.041-.103a12.632 12.632 0 0 1-1.802-.872a.075.075 0 0 1-.007-.124c.12-.089.24-.182.355-.276a.076.076 0 0 1 .079-.009c3.844 1.764 8.01 1.764 11.77 0a.077.077 0 0 1 .078.009c.115.094.235.187.355.276a.075.075 0 0 1-.007.124a12.61 12.61 0 0 1-1.802.872a.075.075 0 0 0-.04.103a14.82 14.82 0 0 0 1.281 1.92a.077.077 0 0 0 .08.027a20.57 20.57 0 0 0 6.097-3.097a.083.083 0 0 0 .032-.058c.484-5.025-.774-9.312-3.617-13.67a.075.075 0 0 0-.032-.027ZM8.02 15.332c-1.18 0-2.155-1.085-2.155-2.418c0-1.332.955-2.418 2.155-2.418c1.21 0 2.176 1.103 2.155 2.418c0 1.332-.955 2.418-2.155 2.418Zm7.974 0c-1.18 0-2.155-1.085-2.155-2.418c0-1.332.955-2.418 2.155-2.418c1.21 0 2.176 1.103 2.155 2.418c0 1.332-.955 2.418-2.155 2.418Z" />
                </svg>
              </a>
            </div>
            
            <Link to="/games" className="inline-block mt-6 px-4 py-2 bg-cyan-950/30 border border-cyan-500/50 text-cyan-400 text-xs font-bold uppercase tracking-widest hover:bg-cyan-500 hover:text-black transition-all rounded">
              EXPLORE OUR MARKET
            </Link>
            
            <p className="text-xs text-slate-600 mt-4">Stay updated with the latest drops and community news.</p>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-slate-600">
          <p>© 2026 P2W Marketplace. All rights reserved.</p>
          <div className="flex gap-8">
            <span className="flex items-center gap-1"><ShieldCheck size={14} /> SSL Secured</span>
            <span className="flex items-center gap-1"><FileText size={14} /> Registered Entity</span>
          </div>
        </div>
      </div>
    </footer>;
}